import { render } from "./clientdataset-list.vue?vue&type=template&id=f5da5a18"
import script from "./clientdataset-list.vue?vue&type=script&lang=js"
export * from "./clientdataset-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__